<template>
  <el-card class="data-table-container" :body-style="{ padding: '20px' }">
    <slot name="header"></slot>
    <h3 v-if="tableTitle">{{ tableTitle }}</h3>
    <div :id="tableId">
      <el-table
        :data="tableData"
        :height="tableHeight"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          type="index"
          align="center"
          :label="$t('commonMsg.No')"
          fixed="left"
          width="50"
          :key="Math.random()"
        >
        </el-table-column>
        <el-table-column
          v-for="{ prop, label, btn, width } in tableProps"
          align="center"
          show-overflow-tooltip
          :prop="prop"
          :key="prop"
          :label="label"
          :fixed="prop === 'handle' && fixedHandle ? 'right' : false"
          :width="width"
        >
          <template slot-scope="scope">
            <div v-if="prop === 'date'">
              <span>{{ scope.row[prop] | filterDate }}</span>
            </div>
            <div v-if="prop === 'userRole-tag'">
              <span>{{ scope.row["tag"] | filterUserRoleTag }}</span>
            </div>
            <div v-if="prop === 'userRole-engine'">
              <span>{{ scope.row["engine"] | filterUserRoleEngine }}</span>
            </div>
            <div v-else-if="prop === 'handle'">
              <el-dropdown
                v-if="handleMode === 'dropdown'"
                trigger="click"
                @command="(cmd) => tableHandle(cmd, scope)"
                placement="bottom"
              >
                <span class="handle-trigger">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in btn"
                    :key="item"
                    :command="item"
                  >
                    <span
                      :class="
                        item === $t('commonMsg.remove') ||
                        item === $t('commonMsg.del')
                          ? 'delBtn'
                          : 'checkDetailsBtn'
                      "
                      >{{ item }}</span
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <template v-else>
                <span
                  class="handle-btn"
                  v-for="item in btn"
                  :key="item"
                  @click="tableHandle(item, scope)"
                  :class="
                    item === $t('commonMsg.remove')
                      ? 'delBtn'
                      : 'checkDetailsBtn'
                  "
                  >{{ item }}</span
                >
              </template>
            </div>
            <div v-else-if="prop === 'move'" class="dataTable-move">
              <i
                class="move-up"
                v-if="scope.$index !== 0"
                @click="tableSort('up', scope)"
              ></i>
              <i
                class="move-down"
                v-if="scope.$index !== tableData.length - 1"
                @click="tableSort('down', scope)"
              ></i>
            </div>
            <span v-else>{{ scope.row[prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <slot name="footer"></slot>
  </el-card>
</template>

<script>
import ResizeMixin from "@/mixins/resize";
export default {
  mixins: [ResizeMixin],
  props: {
    tableTitle: {
      type: String,
    },
    tableId: {
      type: String,
      default: "table-wrap",
    },
    tableData: {
      type: Array,
    },
    tableProps: {
      type: Array,
    },
    fixedHandle: {
      type: Boolean,
      default: true,
    },
    // 操作列渲染方式: 'buttons'(默认, 平铺文字按钮) | 'dropdown'(收进下拉菜单)
    handleMode: {
      type: String,
      default: "buttons",
    },
  },
  data() {
    return {};
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },

    // 表格上下移动排序
    tableSort(type, scope) {
      this.emitEvn(type, scope, "tableSort");
    },

    // 表格操作按钮
    tableHandle(type, scope) {
      this.emitEvn(type, scope, "tableHandle");
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type,
        data: scope,
      };
      this.$emit(evn, obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.data-table-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  h3 {
    margin-bottom: 10px;
    text-align: center;
    color: $globalFontSizeColor;
  }
  #table-wrap {
    flex: 1;
    overflow: hidden;
    .handle-btn {
      cursor: pointer;
    }
    .handle-trigger {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 4px;
      cursor: pointer;
      color: $globalFontSizeColor;
      font-size: 18px;
      outline: none;
      &:hover {
        background: #f0f0f0;
      }
    }
    .dataTable-move {
      > i {
        display: inline-block;
        width: 22px;
        height: 22px;
        cursor: pointer;
        font-size: 20px;
        margin: 0 5px;
        font-weight: bold;
        vertical-align: middle;
      }
      .move-up {
        background: url("~@/assets/img/cmb_move_up.png") no-repeat;
      }
      .move-down {
        background: url("~@/assets/img/cmb_move-down.png") no-repeat;
      }
    }
  }
  #table-first {
    @extend #table-wrap;
  }
  #table-second {
    @extend #table-wrap;
  }
}
</style>
